import { observer } from "mobx-react";
import {
  AppShell,
  createStyles,
  Header,
  Flex,
  Text,
  Modal,
  Menu,
  Tooltip,
  Button,
} from "@mantine/core";
import User from "../User";
import { useCallback, useEffect, useState } from "react";
import { useMediaQuery } from "@mantine/hooks";
import Logo from "../../../components/Logo";
import DgLogo from "../../../components/DgLogo";
import { useStore } from "../../../hooks/use-store";
import useIsMobile from "../../../hooks/isMobile";
import { useRequest } from "ahooks";
import { NOTIFICATION_SERVICE } from "../../../components/notifications/NotificationService";
import { BillingModal } from "../BillingModal";
import ReactPlayer from 'react-player';
import { AccessBillingModal } from "../AccessBillingModal";
import InternalQueue from "./InternalQueue";
import History from './History'
// import CanvasScreen from './CanvasScreen'
import { MODE_2 } from "../../../stores/data/space-store/space-store";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import Gallery from "./Gallery";
import { Models } from "./Models";
import { CreateWorkflow } from "./CreateWorkflow";
import Examples from "./Examples";
import Questionnaire from "../../../pages/public/questionnaire/Questionnaire";
import { BuyCreditsModal } from "../BuyCreditsModal";
import { Workspace } from "./Workspace";

// export const priceMap = {
//   "UPSCALE": 10,
//   "CREATE_NEW": 2,
//   "PLACE_CAR": 10,
//   "OUTPAINT": 8,
//   "CUSTOM_MODEL_GEN": 8,
//   "VARIATIONS": 8
// }

export const priceMap = {
  "THREE_D": 8,
  "PLACE_CAR": 8,
  "CAR_LORA": 8,
  "VARIATIONS": 8,
  "AI_RETOUCH": 10,
  "AI_RETOUCH_2": 10,
  "AI_RETOUCH_3": 10,
  "INPAINT": 10,

  "FIX_RIMS": 10,
  "REMOVE_OBJECT": 10,
  "CAMERA_ROTATE": 10,
  "FILL_CAR": 10,
  "SHUTTER_IMAGE_360": 10,
  "SHUTTER_IMAGE_HDR": 100,
  "ENLARGE": 12,
  "UPSCALE": 10,
  "UPSCALE_V2": 10,
  "UPSCALE_FREEPIK": 10,
  "IMG2IMGFLUX": 10,
  "PLACE_CAR_V4": 10,
  "PLACE_CAR_V2": 10,
  "KLING": 100,
  "VEO": 100,
  "HAILUO": 100,
  "SEEDANCE": 100,

  "LOCATION_TRAIN": 20,
  "OUTPAINT": 10,
  "TRAIN": 50,
}

const useStyles = createStyles((theme) => ({
  logo: {
    display: "flex",
    "> svg": {
      height: "24px",
    },
  },

  cardItem: {
    cursor: "pointer",
    // "img": {
    //   objectFit: "cover",
    // },
    // '&:hover': {
    //   '> div': {
    //     display: 'block !important'
    //   }
    // }
  },

  // hiden: {
  //   display: 'none'
  // },
  card: {
    // backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
    border: '1px solid rgba(70, 70, 70, 1)'
  },

  cardTitle: {
    fontWeight: 700,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    lineHeight: 1.2,
  },

  body: {
    padding: theme.spacing.md,
    background: 'rgba(16, 16, 16, 1)',
  },

  wrapper: {
    // height: "calc(100vh - 84px)",
    // height: "calc(100vh)",
    maxWidth: "100%",
    width: "100%",

  },

  title: {
    marginBottom: theme.spacing.sm,
    paddingLeft: theme.spacing.sm,
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    // fontFamily: `Greycliff CF, ${theme.fontFamily}`,
  },

  item: {
    fontSize: theme.fontSizes.sm,
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[1]
        : theme.colors.gray[7],
  },

  center: {
    display: "flex",
    justifyContent: "center",
  },
  video: {
    margin: "0 auto",

    "> div": {
      position: "absolute!important" as any,
      transformOrigin: "left top",
      borderRadius: "8px",
      overflow: "hidden",
    },
  },
}));


const Element = () => {

  const {
    uiStore: { authStore },
    dataStore: { spaceStore, appStore },

  } = useStore();


  const showQuestionnaire = authStore.currentUser?.plan === 'FREE'

  let logo = null
  let mainColor = 'white'
  if (authStore.currentUser !== null) {
    if (authStore.currentUser?.customization === 'dg') {
      logo = <DgLogo size={240} />
      mainColor = '#939598'
    } else {
      logo = <Logo size={40} />
      mainColor = '#f53c02'
    }
  }
  const isMobile = useIsMobile()

  const { classes } = useStyles();

  // const tiguanLoraUsers = (
  //   authStore.currentUser?.id === 'user_gbiIir1nLvbrfkiNI_pYo'
  //   || authStore.currentUser?.id === 'user_jKO4RFY8WyAV72jLWFg7g'
  //   || authStore.currentUser?.id === 'user_jq3MVJrq1AsUU_nDD4Mas'
  //   || authStore.currentUser?.id === 'user_vKpNcEB-RDH-QZH6bArzv'
  // )

  // const volvoLoraUsers = (
  //   authStore.currentUser?.id === 'user_k_McJZ0_LViQXlqY4S0pi'
  // )

  const history = useHistory();
  const routerLocation = useLocation()

  const secretModeEnabled = authStore.currentUser?.id === 'user_ncW1SxIG5X3mwQGtmPp5Z' || authStore.currentUser?.id === 'user_ztvePOlS8Ylq0N0c5wFhK' || authStore.currentUser?.id === 'user_RzgcIMD1nu3VgXxx1ohCx' || authStore.currentUser?.id === 'user_bwxZh45ttxCf6U3MQeJCc'
  const veit = authStore.currentUser?.id === 'user_Bj-uUfbHhVh-KMkcTjVeE'
  const genesisMode = authStore.currentUser?.id === 'user_s3aVjccTKxcnUYslz2-gB' || secretModeEnabled
  // const audiThMode = authStore.currentUser?.id === 'user_GFlUPjOFZH7yzZZCnkP2-' || authStore.currentUser?.id === 'user_i4v9e-_x7c6houFvhfi10' || secretModeEnabled


  const [onboardingVideo, setOnboardingVideo] = useState(false);
  const [canSkip, setCanSkip] = useState(true);

  // Search results modal state
  const [searchResultsModal, setSearchResultsModal] = useState<{
    open: boolean;
    imageUrl?: string;
    hdrUrl?: string;
  }>({
    open: false,
    imageUrl: undefined,
    hdrUrl: undefined,
  });

  const closeOnboarding = () => {
    window.localStorage.setItem("onboarding", "passed");
    setOnboardingVideo(false);
  }
  // useEffect(() => {
  //   const setting = window.localStorage.getItem("onboarding");
  //   if (setting && setting === "passed") {

  //   } else {
  //     setOnboardingVideo(true);
  //   }

  // }, []);

  const isDesktop = useMediaQuery(`(min-width: 500px)`);

  // const [trainModel, setTrainModel] = useState<{ open: boolean, step: number, images: string[], name: string, description: string, consent: boolean }>({
  //   open: false,
  //   step: 1,
  //   images: [
  //   ],
  //   name: '',
  //   consent: true,
  //   description: ''
  // });


  const { runAsync } = useRequest(
    async (recordId: number) =>
      appStore.getPipelines(recordId),
    {
      loadingDelay: 0,
      manual: true,
      onSuccess: (model) => { },
    }
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { runAsync: addToFeatured } = useRequest(
    async (model: { id: string }) => appStore.addToFeatured({
      id: model.id,
    }),
    {
      manual: true,
      onSuccess: (res) => {
        if (res.error) {
          NOTIFICATION_SERVICE.errorNotification(
            "Sorry, service is unavailable due to high demand. Please try later"
          );
        } else {
          authStore.syncUser();
          return res.url
        }
      },
    }
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { loading: searchInMagroundLoading, runAsync: searchInMaground } = useRequest(
    async (model: { src: string }) => appStore.searchInMaground({
      src: model.src,
    }),
    {
      manual: true,
      onSuccess: (res) => {
        if (res.error) {
          NOTIFICATION_SERVICE.errorNotification(
            "Sorry, service is unavailable due to high demand. Please try later"
          );
        } else {
          // authStore.syncUser();
          return res.url
        }
      },
    }
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { loading: searchInHdrMagroundLoading, runAsync: searchInHdrMaground } = useRequest(
    async (model: { src: string }) => appStore.searchInHdrMaground({
      src: model.src,
    }),
    {
      manual: true,
      onSuccess: (res) => {
        if (res.error) {
          NOTIFICATION_SERVICE.errorNotification(
            "Sorry, service is unavailable due to high demand. Please try later"
          );
        } else {
          // authStore.syncUser();
          return res.url
        }
      },
    }
  );

  const syncBilling = useCallback(async (event: any) => {
    if (event.key === "sync") {
      authStore.syncUser();
      setTimeout(async () => {
        authStore.syncUser();
      }, 4000)
    }
  }, [authStore]);


  useEffect(() => {
    window.addEventListener("storage", syncBilling);

    return () => {
      window.removeEventListener("storage", syncBilling);
    };
  }, [syncBilling]);

  if (isMobile) {
    return (
      <Flex h="100%" w={'100%'} align={'center'} justify={'center'} p={24}>
        <Text align="center">
          <b style={{ marginBottom: '4px', fontSize: '18px' }}>MAGROUND.AI Best Viewed on Larger Screens</b>
          <br />
          Thank you for signing up! MAGROUND.AI is currently optimized for desktop and laptop use. For the best experience, please access the platform on a larger screen. Mobile support is coming soon!
        </Text>
      </Flex>
    )
  }

  return (
    <AppShell
      padding={0}
      fixed
      header={
        isDesktop ? (
          <Header height={{ base: '84px' }} p="md" bg={'transparent'} withBorder={false}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '100%' }}>

              <Flex className={classes.logo} onClick={() => history.push('/')} w="400px" ml={12}>
                {logo}
              </Flex>

              <Flex bg={'rgba(32, 32, 32, 1)'} pl={8} pr={8} pt={6} pb={6} gap={4} align={'center'} justify={'center'} sx={{ borderRadius: '6px' }}>
                <Tooltip
                  color="dark"
                  label="Home"
                  offset={14}
                  position="bottom"
                  radius="md"
                >
                  <Flex p={8} h="38px" w="38px" align="center" justify="center" style={{ cursor: 'pointer', borderRadius: '4px' }} onClick={() => history.push('/')} bg={routerLocation.pathname === '/' ? "rgba(255, 255, 255, 1)" : 'transparent'}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.2802 2.78994L20.0402 6.81994C21.1402 7.58994 22.0102 9.24994 22.0102 10.5999V17.3799C22.0102 19.9299 19.9402 21.9999 17.3902 21.9999H16.1694C15.6171 21.9999 15.1694 21.5522 15.1694 20.9999V14.5942C15.1694 14.042 14.7217 13.5942 14.1694 13.5942H9.83008C9.27779 13.5942 8.83008 14.042 8.83008 14.5942V20.9999C8.83008 21.5522 8.38236 21.9999 7.83008 21.9999H6.61023C4.06023 21.9999 1.99023 19.9199 1.99023 17.3699V10.4699C1.99023 9.20994 2.78023 7.60994 3.78023 6.82994L8.79023 2.91994C10.3002 1.74994 12.7102 1.68994 14.2802 2.78994Z" fill={routerLocation.pathname === '/' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                    </svg>
                  </Flex>

                </Tooltip>

                {
                  (secretModeEnabled || veit) && (
                    <Tooltip
                      color="dark"
                      label="Workspace"
                      offset={14}
                      position="bottom"
                      radius="md"
                    >
                      <Flex p={8} h="38px" w="38px" align="center" justify="center" style={{ cursor: 'pointer', borderRadius: '4px' }} onClick={() => history.push('/workspace')} bg={routerLocation.pathname === '/workspace' ? "rgba(255, 255, 255, 1)" : 'transparent'}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 3.05005H6.5C6.63807 3.05005 6.75 3.16198 6.75 3.30005V6.80005C6.75 6.93584 6.63579 7.05005 6.5 7.05005H3C2.86193 7.05005 2.75 6.93812 2.75 6.80005V3.30005C2.75 3.16198 2.86193 3.05005 3 3.05005Z" fill={routerLocation.pathname === '/workspace' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} stroke={routerLocation.pathname === '/workspace' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} stroke-width="1.5" />
                          <path d="M21.5 3.30005C21.5 2.74776 21.0523 2.30005 20.5 2.30005H17C16.4477 2.30005 16 2.74776 16 3.30005V6.80005C16 7.35233 16.4477 7.80005 17 7.80005H20.5C21.05 7.80005 21.5 7.35005 21.5 6.80005V3.30005Z" fill={routerLocation.pathname === '/workspace' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                          <path d="M21.5 17.3C21.5 16.7478 21.0523 16.3 20.5 16.3H17C16.4477 16.3 16 16.7478 16 17.3V20.8C16 21.3523 16.4477 21.8 17 21.8H20.5C21.05 21.8 21.5 21.35 21.5 20.8V17.3Z" fill={routerLocation.pathname === '/workspace' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                          <path d="M7.5 17.3C7.5 16.7478 7.05228 16.3 6.5 16.3H3C2.44772 16.3 2 16.7478 2 17.3V20.8C2 21.3523 2.44772 21.8 3 21.8H6.5C7.05 21.8 7.5 21.35 7.5 20.8V17.3Z" fill={routerLocation.pathname === '/workspace' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                          <path d="M7.5 10.3C7.5 9.74776 7.05228 9.30005 6.5 9.30005H3C2.44772 9.30005 2 9.74776 2 10.3V13.8C2 14.3523 2.44772 14.8 3 14.8H6.5C7.05 14.8 7.5 14.35 7.5 13.8V10.3Z" fill={routerLocation.pathname === '/workspace' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                          <path d="M21.5 10.3C21.5 9.74776 21.0523 9.30005 20.5 9.30005H17C16.4477 9.30005 16 9.74776 16 10.3V13.8C16 14.3523 16.4477 14.8 17 14.8H20.5C21.05 14.8 21.5 14.35 21.5 13.8V10.3Z" fill={routerLocation.pathname === '/workspace' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                          <path d="M14.5 10.3C14.5 9.74776 14.0523 9.30005 13.5 9.30005H10C9.44772 9.30005 9 9.74776 9 10.3V13.8C9 14.3523 9.44772 14.8 10 14.8H13.5C14.05 14.8 14.5 14.35 14.5 13.8V10.3Z" fill={routerLocation.pathname === '/workspace' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                          <path d="M14.5 3.30005C14.5 2.74776 14.0523 2.30005 13.5 2.30005H10C9.44772 2.30005 9 2.74776 9 3.30005V6.80005C9 7.35233 9.44772 7.80005 10 7.80005H13.5C14.05 7.80005 14.5 7.35005 14.5 6.80005V3.30005Z" fill={routerLocation.pathname === '/workspace' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                          <path d="M14.5 17.3C14.5 16.7478 14.0523 16.3 13.5 16.3H10C9.44772 16.3 9 16.7478 9 17.3V20.8C9 21.3523 9.44772 21.8 10 21.8H13.5C14.05 21.8 14.5 21.35 14.5 20.8V17.3Z" fill={routerLocation.pathname === '/workspace' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                        </svg>
                      </Flex>
                    </Tooltip>)
                }

                <Tooltip
                  color="dark"
                  label="Create generation"
                  offset={14}
                  position="bottom"
                  radius="md"
                >
                  <Flex
                    data-intercom-target={
                      'MagicWandIcon'
                    }
                    p={8} h="38px" w="38px" align="center" justify="center" style={{ cursor: 'pointer', borderRadius: '4px' }} onClick={() => history.push('/generate')} bg={routerLocation.pathname === '/generate' ? "rgba(255, 255, 255, 1)" : 'transparent'}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18.0002 4.63C18.3088 4.63005 18.6117 4.72911 18.8645 4.93567L18.97 5.0304C19.5069 5.5675 19.507 6.4328 18.97 6.96985L18.01 7.92981L16.0705 5.99036L17.0305 5.0304C17.3019 4.75902 17.6477 4.63 18.0002 4.63Z" fill={routerLocation.pathname === '/generate' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} stroke={routerLocation.pathname === '/generate' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} stroke-width="1.5" />
                      <path d="M17.31 9.69995L6.5 20.5C5.67 21.33 4.33 21.33 3.5 20.5C2.67 19.67 2.67 18.33 3.5 17.5L14.31 6.69995L17.31 9.69995Z" fill={routerLocation.pathname === '/generate' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                      <path d="M9.95 3.50002L10.36 2.11002C10.4 1.98002 10.36 1.84002 10.27 1.74002C10.18 1.64002 10.02 1.60002 9.89 1.64002L8.5 2.05002L7.11 1.64002C6.98 1.60002 6.84 1.64002 6.74 1.73002C6.64 1.83002 6.61 1.97002 6.65 2.10002L7.05 3.50002L6.64 4.89002C6.6 5.02002 6.64 5.16002 6.73 5.26002C6.83 5.36002 6.97 5.39002 7.1 5.35002L8.5 4.95002L9.89 5.36002C9.93 5.37002 9.96 5.38002 10 5.38002C10.1 5.38002 10.19 5.34002 10.27 5.27002C10.37 5.17002 10.4 5.03002 10.36 4.90002L9.95 3.50002Z" fill={routerLocation.pathname === '/generate' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                      <path d="M5.95 9.50002L6.36 8.11002C6.4 7.98002 6.36 7.84002 6.27 7.74002C6.17 7.64002 6.03 7.61002 5.9 7.65002L4.5 8.05002L3.11 7.64002C2.98 7.60002 2.84 7.64002 2.74 7.73002C2.64 7.83002 2.61 7.97002 2.65 8.10002L3.05 9.50002L2.64 10.89C2.6 11.02 2.64 11.16 2.73 11.26C2.83 11.36 2.97 11.39 3.1 11.35L4.49 10.94L5.88 11.35C5.91 11.36 5.95 11.36 5.99 11.36C6.09 11.36 6.18 11.32 6.26 11.25C6.36 11.15 6.39 11.01 6.35 10.88L5.95 9.50002Z" fill={routerLocation.pathname === '/generate' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                      <path d="M20.95 14.5L21.36 13.11C21.4 12.98 21.36 12.84 21.27 12.74C21.17 12.64 21.03 12.61 20.9 12.65L19.51 13.06L18.12 12.65C17.99 12.61 17.85 12.65 17.75 12.74C17.65 12.84 17.62 12.98 17.66 13.11L18.07 14.5L17.66 15.89C17.62 16.02 17.66 16.16 17.75 16.26C17.85 16.36 17.99 16.39 18.12 16.35L19.51 15.94L20.9 16.35C20.93 16.36 20.97 16.36 21.01 16.36C21.11 16.36 21.2 16.32 21.28 16.25C21.38 16.15 21.41 16.01 21.37 15.88L20.95 14.5Z" fill={routerLocation.pathname === '/generate' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                    </svg>

                  </Flex>
                </Tooltip>
                <Tooltip
                  color="dark"
                  label="History"
                  offset={14}
                  position="bottom"
                  radius="md"
                >
                  <Flex
                    data-intercom-target={
                      'HistoryIcon'
                    }
                    p={8} h="38px" w="38px" align="center" justify="center" style={{ cursor: 'pointer', borderRadius: '4px' }} onClick={() => history.push('/history')} bg={routerLocation.pathname === '/history' ? "rgba(255, 255, 255, 1)" : 'transparent'}>
                    <Flex pos="relative">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.1155 10.1201C17.3751 10.1201 17.512 10.3113 17.512 10.457C17.512 10.6042 17.3747 10.7949 17.1155 10.7949C16.8581 10.7947 16.721 10.6045 16.721 10.457C16.721 10.311 16.8577 10.1203 17.1155 10.1201Z" fill={routerLocation.pathname === '/history' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} stroke={routerLocation.pathname === '/history' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} stroke-width="2" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.036 5.91212C16.976 5.77612 15.622 5.77612 13.913 5.77612H10.087C8.377 5.77612 7.023 5.77612 5.964 5.91212C4.874 6.05312 3.99 6.34912 3.294 7.01612C2.598 7.68412 2.289 8.53012 2.142 9.57612C2 10.5901 2 11.8881 2 13.5271V13.6271C2 15.2661 2 16.5641 2.142 17.5801C2.289 18.6251 2.598 19.4711 3.294 20.1381C3.99 20.8061 4.874 21.1021 5.964 21.2421C7.024 21.3801 8.378 21.3801 10.087 21.3801H13.913C15.623 21.3801 16.977 21.3801 18.036 21.2431C19.126 21.1031 20.01 20.8071 20.706 20.1391C21.402 19.4721 21.711 18.6261 21.858 17.5811C22 16.5651 22 15.2671 22 13.6281V13.5281C22 11.8881 22 10.5911 21.858 9.57512C21.711 8.53012 21.402 7.68412 20.706 7.01612C20.01 6.34912 19.126 6.05312 18.036 5.91212ZM6.15 7.23812C5.214 7.35812 4.675 7.58512 4.28 7.96212C3.887 8.34012 3.651 8.85612 3.525 9.75312C3.425 10.4731 3.402 11.3731 3.397 12.5491L3.867 12.1541C4.992 11.2111 6.686 11.2651 7.742 12.2771L11.732 16.1021C11.9297 16.2886 12.1849 16.4024 12.4558 16.4249C12.7267 16.4475 12.9972 16.3774 13.223 16.2261L13.501 16.0391C14.1531 15.603 14.9297 15.3915 15.7129 15.4366C16.4961 15.4817 17.2433 15.781 17.841 16.2891L20.248 18.3671C20.346 18.1031 20.421 17.7871 20.475 17.4021C20.603 16.4861 20.605 15.2781 20.605 13.5781C20.605 11.8781 20.603 10.6701 20.475 9.75312C20.349 8.85612 20.113 8.34012 19.719 7.96312C19.326 7.58512 18.786 7.35912 17.85 7.23812C16.894 7.11512 15.634 7.11312 13.86 7.11312H10.14C8.366 7.11312 7.106 7.11512 6.15 7.23812Z" fill={routerLocation.pathname === '/history' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                        <path d="M17.086 2.99013C16.226 2.88013 15.132 2.88013 13.767 2.88013H10.677C9.31299 2.88013 8.21799 2.88013 7.35799 2.99013C6.46799 3.10513 5.72599 3.34813 5.13699 3.91013C4.81193 4.22215 4.56404 4.60562 4.41299 5.03013C4.91699 4.80013 5.48699 4.66413 6.12699 4.58013C7.21099 4.44013 8.59699 4.44013 10.347 4.44013H14.261C16.011 4.44013 17.396 4.44013 18.481 4.58013C19.039 4.65313 19.545 4.76613 20 4.94613C19.847 4.5551 19.6109 4.20196 19.308 3.91113C18.719 3.34813 17.977 3.10513 17.086 2.99113" fill={routerLocation.pathname === '/history' ? "rgba(16, 16, 16, 1)" : '#BDBDBD'} />
                      </svg>
                      {spaceStore.pipelines.filter(p => p.status === 'pending' || p.status === 'ending').length > 0 && (
                        <Flex
                          pos="absolute"
                          top={-8}
                          right={-8}
                          bg="#f53c02"
                          w={20}
                          h={20}
                          style={{ borderRadius: '50%' }}
                          align="center"
                          justify="center"
                        >
                          <Text fz={9} c="white" fw={700}>
                            {spaceStore.pipelines.filter(p => p.status === 'pending' || p.status === 'ending').length}
                          </Text>
                        </Flex>
                      )}
                    </Flex>
                  </Flex>
                </Tooltip>
              </Flex>
              <Flex gap={12} w="400px" justify={'flex-end'}>

                <User
                  block={
                    <>
                      {
                        (
                          (authStore.currentUser?.plan === 'FREE' || authStore.currentUser?.plan === 'BOOSTED') ? null :
                            <Menu.Item
                              icon={null}
                              onClick={() => {
                                spaceStore.setBuyCreditsModalOpen(true)
                              }}
                            >
                              Buy credits
                            </Menu.Item>
                        )
                      }
                      {
                        genesisMode ? (
                          <>
                            <Menu.Item
                              icon={null}
                              onClick={async () => {
                                spaceStore.setMode2(MODE_2.PLACE_CAR_V4)
                                history.push('/generate')
                              }}
                            >
                              [beta] Place Car Genesis V4
                            </Menu.Item>
                            <Menu.Item
                              icon={null}
                              onClick={async () => {
                                spaceStore.setMode2(MODE_2.FIX_RIMS)
                                history.push('/generate')
                              }}
                            >
                              [beta] Fix Rims
                            </Menu.Item>
                          </>
                        ) : null
                      }
                      {
                        secretModeEnabled && <>
                          <Menu.Item
                            icon={null}
                            onClick={async () => {
                              spaceStore.setMode2(MODE_2.PLACE_CAR_V2)
                              history.push('/generate')
                            }}
                          >
                            [beta] Place Car Iclight
                          </Menu.Item>
                          <Menu.Item
                            icon={null}
                            onClick={async () => {
                              spaceStore.setMode2(MODE_2.PLACE_CAR_K)
                              history.push('/generate')
                            }}
                          >
                            [beta] Place Car Kontext
                          </Menu.Item>       <Menu.Item
                            icon={null}
                            onClick={async () => {
                              spaceStore.setMode2(MODE_2.PLACE_CAR_NANO_BANANA)
                              history.push('/generate')
                            }}
                          >
                            [beta] Place Car Nano Banana
                          </Menu.Item>
                        </>
                      }
                    </>}
                  mainColor={mainColor}
                  secretModeEnabled={secretModeEnabled}
                  buyCredits={() => spaceStore.setBillingAccessModalOpen(true)}
                  buyAccess={() => spaceStore.setBillingAccessModalOpen(true)}
                  billingHistory={async () => {
                    const res = await appStore.getPortalLink()
                    if (res.url) {

                      let a = document.createElement('a');
                      a.target = '_blank';
                      a.href = res.url;
                      a.click();
                    } else {
                    }
                  }}
                />
              </Flex>
            </div>
          </Header >
        ) :
          (
            <Header height={{ base: 50, md: 70 }} p="md" bg={'rgba(16, 16, 16, 1)'}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '100%' }}>
                <div className={classes.logo}>
                  {logo}
                </div>
              </div>
            </Header>
          )
      }


      styles={(theme) => ({
        main: {
          backgroundColor:
            'rgba(16, 16, 16, 1)'
        },
      })}
    >

      <Flex className={classes.wrapper} gap={12} style={{
        padding: routerLocation.pathname === '/canvas' ? '0' : '0 1rem',
        height: routerLocation.pathname === '/history' || routerLocation.pathname === '/canvas' ? 'calc(100vh - 84px)' : undefined
      }}>

        <Modal
          opened={showQuestionnaire}
          onClose={() => {

          }}
          title={' '}
          size={'1100px'}
          transitionProps={{ transition: 'fade', duration: 200, }}
          styles={{
            root: {
              padding: 0
            },

            close: {
              display: 'none'
            }
          }}
        >
          <Questionnaire />
        </Modal>
        <Modal
          opened={onboardingVideo}
          onClose={() => {
            if (canSkip) {
              closeOnboarding()
            }
          }}
          title={' '}
          size={'1200px'}
          transitionProps={{ transition: 'fade', duration: 200 }}
          styles={{
            close: {
              display: canSkip ? 'default' : 'none'
            }
          }}
        >
          <Flex w='100%' justify={'center'}>

            <Flex direction={'column'} maw={'800px'} mb={30} gap={20} w={'100%'}>
              <Text fz={26} fw={'bold'}>Getting Started with MAGROUND.AI</Text>
              <Text fz={16}>Find more in <a href={'https://support.maground.com/en/articles/9823468-getting-started-with-maground-ai'}>FAQ center</a></Text>
              <Flex w={'100%'}>
                <ReactPlayer
                  autoPlay={true}

                  onStart={() => {
                    setCanSkip(true)
                  }}
                  style={{
                    // borderRadius: props.border.borderRadius || undefined,
                    // borderWidth: props.border.borderWidth || undefined,
                    // borderColor: props.border.borderColor || undefined,
                  }}
                  url={'https://www.youtube.com/watch?feature=shared&v=2SdnfCvNY-I'}
                  controls
                  width="800px"
                  height="450px"
                />
              </Flex>
            </Flex>
          </Flex>


        </Modal>

        {/* <Modal
          opened={trainLocationOpened}
          onClose={() => setTrainLocationOpened(false)}
          title="Location name"
        >
          <Flex direction="column" gap="md">
            <TextInput
              placeholder="Enter location name"
              value={location}
              onChange={(e) => setLocation(e.currentTarget.value)}
            />
            <Button
              styles={{
                root: {
                  color: 'rgba(230, 230, 230, 1)',
                  height: rem(36),

                  fontSize: '14px',
                  background: '#f53c02 !important',
                  border: 'none',
                  position: 'relative',
                }
              }}
              loading={trainLocationLoading}
              onClick={async () => {
                await trainLocation({
                  itemName: location
                })
                // setTrainModel({
                //   ...trainModel,
                //   step: 2
                // })
              }}>
              Train location
            </Button>

          </Flex>
        </Modal> */}

        <BillingModal opened={spaceStore.billingModalOpen} close={() => spaceStore.setBillingAccessModalOpen(false)} ></BillingModal>

        <AccessBillingModal opened={spaceStore.billingAccessModalOpen} close={() => spaceStore.setBillingAccessModalOpen(false)}></AccessBillingModal>

        <BuyCreditsModal opened={spaceStore.buyCreditsModalOpen} close={() => spaceStore.setBuyCreditsModalOpen(false)}></BuyCreditsModal>

        {/* Search Results Modal */}
        <Modal
          opened={searchResultsModal.open}
          onClose={() => setSearchResultsModal({ open: false, imageUrl: undefined, hdrUrl: undefined })}
          title=" "
          size="md"
          centered
        >
          <Flex direction="column" gap="md" align="center">
            <Text align="center" mb="md">
              Your search has been completed.
            </Text>

            {searchResultsModal.imageUrl && (
              <Button
                fullWidth
                size="lg"
                styles={{
                  root: {
                    backgroundColor: '#f53c02',
                    '&:hover': {
                      backgroundColor: '#d63384',
                    },
                  },
                }}
                onClick={() => {
                  window.open(searchResultsModal.imageUrl, '_blank');
                  setSearchResultsModal({ open: false, imageUrl: undefined, hdrUrl: undefined });
                }}
              >
                Open Image Results
              </Button>
            )}

            {searchResultsModal.hdrUrl && (
              <Button
                fullWidth
                size="lg"
                styles={{
                  root: {
                    backgroundColor: '#f53c02',
                    '&:hover': {
                      backgroundColor: '#d63384',
                    },
                  },
                }}
                onClick={() => {
                  window.open(searchResultsModal.hdrUrl, '_blank');
                  setSearchResultsModal({ open: false, imageUrl: undefined, hdrUrl: undefined });
                }}
              >
                Open HDR Results
              </Button>
            )}

          </Flex>
        </Modal>

        <Flex w={'100%'} pos="relative" bg="rgba(16, 16, 16, 1)" style={{ borderRadius: '8px', overflowY: 'scroll', height: '100%', minHeight: 'calc(100vh - 100px)' }} direction={'column'}>
          <Switch>
            <Route exact path="/gallery">
              <Gallery />
            </Route>
            <Route exact path="/">
              <Examples />
            </Route>
            <Route exact path="/history">
              <History
                loadMore={async () => {
                  const lastPipeline = spaceStore.pipelines[spaceStore.pipelines.length - 1]
                  const load = await runAsync(lastPipeline?.record_id)
                  console.log(lastPipeline)
                  if (load.length > 0) {
                    spaceStore.setPipelines([...spaceStore.pipelines, ...load.sort((a, b) => a.data.createdAt > b.data.createdAt ? -1 : 1)])
                  } else {
                    NOTIFICATION_SERVICE.successNotification('No more generations')
                  }
                }}
                addFeatured={async (jobId) => {
                  await addToFeatured({
                    id: jobId,
                  })

                  NOTIFICATION_SERVICE.successNotification('Added to featured, refresh page')
                }}
                onRemoveObject={async (image) => {
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  spaceStore.setMode2(MODE_2.REMOVE_OBJECT)
                  history.push('/generate')
                }}
                onFillCarObject={async (image) => {
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  spaceStore.setMode2(MODE_2.FILL_CAR)
                  history.push('/generate')
                }}
                searchInMaground={async (image) => {
                  const res = await searchInMaground({ src: image })

                  if (res.url) {
                    setSearchResultsModal({
                      open: true,
                      imageUrl: res.url,
                      hdrUrl: undefined
                    })
                  } else {
                    NOTIFICATION_SERVICE.errorNotification('Sorry, try again later')
                  }

                }}
                searchInHdrMaground={async (image) => {
                  const res = await searchInHdrMaground({ src: image })

                  if (res.url) {
                    setSearchResultsModal({
                      open: true,
                      imageUrl: undefined,
                      hdrUrl: res.url
                    })
                  } else {
                    NOTIFICATION_SERVICE.errorNotification('Sorry, try again later')
                  }

                }}
                secretModeEnabled={secretModeEnabled}
                openCustomModelVersion={async (version, prompt, ratio) => {
                  console.log(version, prompt, ratio)
                  const model = spaceStore.gallery.find(itm => itm.modelVersion === version)
                  const privateModel = spaceStore.privateModels.find(itm => itm.version === version)

                  console.log(model, privateModel)
                  // {
                  //     model: {
                  //       images: item.data.images.map((itm: { url: string, preview: string }) => itm.url),
                  //       mainImage: item.data.images[0].url,
                  //       name: item.name,
                  //       modelVersion: item.version,
                  //       status: 'competed',
                  //     }
                  //   }
                  if (model) {
                    spaceStore.setSelectedModel({
                      model: {
                        images: model.images.map((itm: { url: string, preview: string }) => itm.url),
                        mainImage: model.images[0].url,
                        name: model.loraPath!,
                        modelVersion: model.modelVersion,
                        status: 'competed',
                      }
                    })
                  } else if (privateModel) {
                    spaceStore.setSelectedModel({
                      model: {
                        images: privateModel.data.images.map((itm: { url: string, preview: string }) => itm.url),
                        mainImage: privateModel.data.images[0].url,
                        name: privateModel.name!,
                        modelVersion: privateModel.version,
                        status: 'competed',
                      }
                    })
                  } else {
                    NOTIFICATION_SERVICE.errorNotification('Model not found')
                    return
                  }
                  spaceStore.setMode2(MODE_2.VARIATIONS)
                  // spaceStore.clearLatest()
                  history.push('/generate')
                  spaceStore.setPrompt(prompt)
                  spaceStore.setRatio(ratio)
                }}
                openBillingModal={async () => {
                  spaceStore.setBillingAccessModalOpen(true)
                }}
                onUpscaleHdrV1={async (image, type) => {
                  spaceStore.setMode2(MODE_2.UPSCALE_HDR_V1)
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}
                onUpscale={async (image, type) => {
                  if (type === 'TOPAZ') {
                    spaceStore.setMode2(MODE_2.UPSCALE)
                  } else if (type === 'TOPAZ_ENHANCED') {
                    spaceStore.setMode2(MODE_2.UPSCALE_V2)
                  } else if (type === 'FREEPIK') {
                    spaceStore.setMode2(MODE_2.UPSCALE_FREEPIK)
                  }
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}
                makeVariations={async (image) => {
                  spaceStore.setMode2(MODE_2.IMG2IMGFLUX)
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}
                placeCar={async (image) => {
                  // spaceStore.setSelectedImage({
                  //   src: image
                  // })
                  // spaceStore.setMode2(MODE_2.IMPORT_CAR);
                  // history.push('/generate')
                }}

                onEnlarge={async (image) => {
                  spaceStore.setMode2(MODE_2.ENLARGE)

                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')

                }}
                create360={async (image) => {
                  spaceStore.setMode2(MODE_2.SHUTTER_IMAGE_360)
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}
                createHDR={async (image) => {
                  spaceStore.setMode2(MODE_2.SHUTTER_IMAGE_HDR)
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}
                onMoodEnhance={async (image) => {
                  // spaceStore.setMode2(MODE_2.AI_RETOUCH)
                  // spaceStore.setSelectedImage({
                  //   src: image
                  // })
                  // history.push('/generate')
                }}
                onAiRetouch2={async (image) => {
                  spaceStore.setMode2(MODE_2.AI_RETOUCH_2)
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}
                onCameraRotate={async (image) => {
                  spaceStore.setMode2(MODE_2.CAMERA_ROTATE)
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}
                changeBackground={async (image) => {
                  spaceStore.setMode2(MODE_2.PLACE_CAR)
                  spaceStore.setCarImg(image)
                  history.push('/generate')
                }}
                onAiRetouch3={async (image) => {
                  // spaceStore.setMode2(MODE_2.AI_RETOUCH_3)
                  // spaceStore.setSelectedImage({
                  //   src: image
                  // })
                  // history.push('/generate')
                }}
                onInpaint={async (image) => {
                  spaceStore.setMode2(MODE_2.INPAINT)
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}

                onCreateImageKling={async (image) => {
                  spaceStore.setMode2(MODE_2.KLING)
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}

                onCreateImageVeo={async (image) => {
                  spaceStore.setMode2(MODE_2.VEO)
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}

                onCreateImageHailuo={async (image) => {
                  spaceStore.setMode2(MODE_2.HAILUO)
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}
                onCreateImageSeedance={async (image) => {
                  spaceStore.setMode2(MODE_2.SEEDANCE)
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}
                onCreateImageWan={async (image) => {
                  spaceStore.setMode2(MODE_2.WAN)
                  spaceStore.setSelectedImage({
                    src: image
                  })
                  history.push('/generate')
                }}
              />
            </Route>
            {/* <Route exact path="/canvas">
              <CanvasScreen />
            </Route> */}
            <Route path="/workspace">
              <Workspace />
            </Route>
            <Route path="/generate">

              {
                spaceStore.selectedModel || spaceStore.selectedImage || spaceStore.mode2 ? <CreateWorkflow /> : <Models />
              }

            </Route>
          </Switch>
        </Flex>
        {/* <PipelineHistory mainColor={mainColor} /> */}
        <InternalQueue />

      </Flex>
    </AppShell >
  );
};

export const Router = observer(Element);